import React from 'react';
import { ScrollReveal } from './ui/ScrollReveal';
import { ShieldCheckIcon, CreditCardIcon, LockIcon, MessageCircleIcon, ClockIcon, TrendingUpIcon, AwardIcon, CheckCircleIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
interface FinalOfferProps {
  isOrderBumpChecked: boolean;
}
export function FinalOffer({
  isOrderBumpChecked
}: FinalOfferProps) {
  const basePrice = 17990;
  const bumpPrice = 7500;
  const totalPrice = isOrderBumpChecked ? basePrice + bumpPrice : basePrice;
  return <section id="checkout" className="py-20 bg-cream relative" data-id="element-13">
      <div className="max-w-3xl mx-auto px-4" data-id="element-14">
        <ScrollReveal data-id="element-15">
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-forest/10" data-id="element-16">
            {/* Header */}
            <div className="bg-forest p-8 text-center text-white" data-id="element-17">
              <h2 className="font-serif text-2xl md:text-3xl font-bold mb-2" data-id="element-18">
                Resumen de tu Inversión
              </h2>
              <p className="text-forest-100 opacity-90" data-id="element-19">
                Acceso inmediato de por vida
              </p>
            </div>

            {/* Body */}
            <div className="p-8 md:p-10" data-id="element-20">
              <div className="flex justify-between items-center mb-4 text-lg text-brown/80" data-id="element-21">
                <span data-id="element-22">Pack Botiquín Ancestral + Bonos</span>
                <span className="font-bold" data-id="element-23">
                  ${basePrice.toLocaleString('es-AR')}
                </span>
              </div>

              {isOrderBumpChecked && <div className="flex justify-between items-center mb-4 text-lg text-forest font-medium animate-fade-in-up" data-id="element-24">
                  <span data-id="element-25">Kit del Sueño Profundo</span>
                  <span className="font-bold" data-id="element-26">
                    + ${bumpPrice.toLocaleString('es-AR')}
                  </span>
                </div>}

              <div className="border-t border-brown/10 my-6" data-id="element-27"></div>

              <div className="flex justify-between items-end mb-8" data-id="element-28">
                <span className="text-xl font-bold text-brown" data-id="element-29">
                  Total a pagar:
                </span>
                <span className="text-4xl md:text-5xl font-bold text-forest" data-id="element-30">
                  ${totalPrice.toLocaleString('es-AR')}
                </span>
              </div>

              <div className="flex items-center justify-center gap-2 text-sm text-brown/60 mb-8 bg-sage/30 p-3 rounded-lg" data-id="element-31">
                <CreditCardIcon className="w-5 h-5 text-blue-500" data-id="element-32" />
                <span data-id="element-33">
                  Pagá seguro en pesos con <strong data-id="element-34">Mercado Pago</strong>{' '}
                  (Débito, Crédito o Saldo)
                </span>
              </div>

              <a href={isOrderBumpChecked ? 'https://www.ebookpromax.com/cart/46629774295198:1' : 'https://www.ebookpromax.com/cart/46629742641310:1'} target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart(isOrderBumpChecked ? 25490 : 17990, 'ARS', isOrderBumpChecked ? 'Botiquín Ancestral + Kit del Sueño' : 'Botiquín Ancestral')} className="block w-full text-center bg-forest text-white font-bold text-lg md:text-xl px-8 py-5 rounded-xl animate-pulse-glow hover:bg-forest/90 transition-colors shadow-lg transform hover:-translate-y-1" data-id="element-35">
                🛒 ACCEDER AL PACK COMPLETO{' '}
                {isOrderBumpChecked && '+ ORDER BUMP'}
              </a>

              {/* Trust Badges - Pago Seguro */}
              <div className="mt-6 rounded-xl border border-forest/15 bg-sage/20 p-5" data-id="element-36">
                {/* Pago seguro header */}
                <div className="flex items-center justify-center gap-2 mb-4" data-id="element-37">
                  <LockIcon className="w-4 h-4 text-forest" data-id="element-38" />
                  <span className="text-sm font-semibold text-forest tracking-wide uppercase" data-id="element-39">
                    Pago seguro garantizado
                  </span>
                </div>

                {/* Payment logos */}
                <div className="flex items-center justify-center gap-4 flex-wrap bg-white rounded-lg border border-forest/10 py-3 px-4 mb-4" data-id="element-40">
                  <img src="https://cdn.magicpatterns.com/uploads/62WMnFnBZS865R3W9ReLgn/WhatsApp_Image_2026-03-22_at_01.13.29.jpg" alt="Medios de pago: Visa, Mastercard, Maestro, Mercado Pago" className="h-24 md:h-28 object-contain rounded" data-id="element-41" />
                </div>

                {/* MercadoLíder */}
                <div className="flex items-center justify-center gap-2 mb-4" data-id="element-42">
                  <AwardIcon className="w-5 h-5 text-forest" data-id="element-43" />
                  <div className="text-center" data-id="element-44">
                    <p className="text-sm font-bold text-forest" data-id="element-45">
                      MercadoLíder Platinum
                    </p>
                    <p className="text-xs text-brown/60" data-id="element-46">
                      ¡Es uno de los mejores del sitio!
                    </p>
                  </div>
                </div>

                {/* Progress bar */}
                <div className="w-full h-2 bg-forest/10 rounded-full mb-5 overflow-hidden" data-id="element-47">
                  <div className="h-full bg-forest rounded-full" style={{
                  width: '100%'
                }} data-id="element-48"></div>
                </div>

                {/* Stats */}
                <div className="grid grid-cols-3 gap-3 text-center" data-id="element-49">
                  <div className="flex flex-col items-center gap-1" data-id="element-50">
                    <TrendingUpIcon className="w-5 h-5 text-forest" data-id="element-51" />
                    <p className="text-lg md:text-xl font-bold text-brown" data-id="element-52">
                      145.121
                    </p>
                    <p className="text-[11px] text-brown/60 leading-tight" data-id="element-53">
                      Ventas en los últimos 60 días
                    </p>
                  </div>
                  <div className="flex flex-col items-center gap-1" data-id="element-54">
                    <div className="relative" data-id="element-55">
                      <MessageCircleIcon className="w-5 h-5 text-forest" data-id="element-56" />
                      <CheckCircleIcon className="w-3 h-3 text-forest absolute -bottom-0.5 -right-1" data-id="element-57" />
                    </div>
                    <p className="text-lg md:text-xl font-bold text-brown" data-id="element-58">
                      Excelente
                    </p>
                    <p className="text-[11px] text-brown/60 leading-tight" data-id="element-59">
                      Brinda buena atención
                    </p>
                  </div>
                  <div className="flex flex-col items-center gap-1" data-id="element-60">
                    <div className="relative" data-id="element-61">
                      <ClockIcon className="w-5 h-5 text-forest" data-id="element-62" />
                      <CheckCircleIcon className="w-3 h-3 text-forest absolute -bottom-0.5 -right-1" data-id="element-63" />
                    </div>
                    <p className="text-lg md:text-xl font-bold text-brown" data-id="element-64">
                      Rápido
                    </p>
                    <p className="text-[11px] text-brown/60 leading-tight" data-id="element-65">
                      Despacha sus productos a tiempo
                    </p>
                  </div>
                </div>
              </div>

              {/* Guarantee */}
              <div className="mt-8 bg-parchment p-6 rounded-xl border border-amber/20 flex gap-4 items-start" data-id="element-66">
                <ShieldCheckIcon className="w-10 h-10 text-amber shrink-0" data-id="element-67" />
                <div data-id="element-68">
                  <h4 className="font-bold text-brown mb-1" data-id="element-69">
                    🔒 Garantía Abuela Sabia
                  </h4>
                  <p className="text-sm text-brown/80 leading-relaxed" data-id="element-70">
                    Si en 7 días no ahorrás al menos el doble de lo que pagaste,
                    te devuelvo el 100%
                  </p>
                </div>
              </div>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>;
}